import { Box, Grid, IconButton, List, ListItem, ListItemIcon, SxProps, Theme, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IsLeo, IsVideo, themeC } from "../theme/themehelper";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import image from '../images/footballfield.jpg';
import kungImage from '../images/kung_syndicates.png';
import kungGroup from '../images/kung_people.png';
import kungValid from '../images/kung_valid.png';
import kungWin from '../images/win_kung.png';
import mrVegasGroup from '../images/mrVegas_people.png';
import mrVegasValid from '../images/mrVegas_check.png';
import mrVegasWin from '../images/mrVegas_win.png';
import megaGroup from '../images/mega_people.png';
import megaValid from '../images/mega_check.png';
import megaWin from '../images/mega_win.png';
import dbetImage from '../images/dbet_syndicate.jpeg';
import videoImage from '../images/video_syndicate.png';
import mrvegasImage from '../images/mrvegas_syndicate.jpeg';
import megaImage from '../images/mega_syndicate.jpeg';
import orangeStadium from '../images/expekt_background.png';
import gogoStadium from '../images/gogo_background.jpg';
import woodLanding from '../images/wood_landing.png';
import leoLanding from '../images/lion_landing.png';
import unibetLanding from '../images/unibet_landing.jpg';
import hajperBackground from '../images/hajper_background.png';
import snabbareBackground from '../images/snabbare_background.png';
import reviantBackground from '../images/reviant_background.jpeg';
import lylloBackground from '../images/lyllo_background.png';
import stuganBackground from '../images/background_stugan.png';
import kryssBackground from '../images/kryss_landing.jpeg';
import comeonBackground from '../images/comeon_background.png';
import hardBackground from '../images/hard_background.png';
import hardBet from '../images/hard_bet.png';
import hardFollow from '../images/hard_follow.png';
import hardWin from '../images/hard_win.png';
import { UnibetBetIcon, UnibetWinIcon, Unibet1x2Logo } from '../images/unibeticons';


const SYNDICATE_BANNER_DISMISSED_KEY = 'syndicate_banner_dismissed';

function SyndicateInfoBox({ theme }: { theme: string }) {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(() => localStorage.getItem(SYNDICATE_BANNER_DISMISSED_KEY) === 'true');

    if (dismissed) {
        return null;
    }

    const handleClose = () => {
        localStorage.setItem(SYNDICATE_BANNER_DISMISSED_KEY, 'true');
        setDismissed(true);
    };

    let backgroundImage = `url(${image})`;

    let borderColor = "";
    let text = 'white';    

    if (theme === themeC.Kung) {
        backgroundImage = `url(${kungImage})`;
        borderColor = "#249CEC";
    }

    if (theme === themeC.Dbet) {
        backgroundImage = `url(${dbetImage})`;
        borderColor = "#F4C004";
    }

    if (theme === themeC.Video) {
        backgroundImage = `url(${videoImage})`;
        borderColor = "#F4C004";
    }

    if (theme === themeC.MrVegas) {
        backgroundImage = `url(${mrvegasImage})`;
        borderColor = "#18723C";
    }

    if (theme === themeC.Mega) {
        backgroundImage = `url(${megaImage})`;
        borderColor = "#B89A54";
    }

    if (theme === themeC.Orange) {
        backgroundImage = `url(${orangeStadium})`;
    }

    if (theme === themeC.GoGo) {
        backgroundImage = `url(${gogoStadium})`;
    }

    if (theme === themeC.Wood) {
        backgroundImage = `url(${woodLanding})`;
    }

    if (theme === themeC.Lion) {
        backgroundImage = `url(${leoLanding})`;
    }

    if (theme === themeC.Green) {
        backgroundImage = `url(${unibetLanding})`;
    }

    if (theme === themeC.ComeOn) {
        backgroundImage = `url(${comeonBackground})`;
    }

    if (theme === themeC.Hajper) {
        backgroundImage = `url(${hajperBackground})`;
    }

    if (theme === themeC.Snabbare || theme === themeC.Reviant) {
        backgroundImage = theme === themeC.Reviant
            ? `url(${reviantBackground})`
            : `url(${snabbareBackground})`;
    }

    if (theme === themeC.Lyllo) {
        backgroundImage = `url(${lylloBackground})`;
    }

    if (theme === themeC.Stugan) {
        backgroundImage = `url(${stuganBackground})`;
    }

    if (theme === themeC.Kryss) {
        backgroundImage = `url(${kryssBackground})`;
    }

    if (theme === themeC.Hard) {
        backgroundImage = `url(${hardBackground})`;
    }

    let boxInPicture: SxProps<Theme> = {
        position: "relative",
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "var(--text-white)",
        padding: "10px",
        "::before": {
            content: '""',
            opacity: "0.7",
            background: "var(--title-bar-background)",
            position: "absolute",
            top: "0px",
            right: "0px",
            bottom: "0px",
            left: "0px",
            borderRadius: 'var(--radius)'
        }
    };

    if (window.theme === themeC.Orange) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "10px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#18192D",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Wood) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "10px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#18192D",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Lion) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "10px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#18192D",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Green) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "16px",
            paddingRight: "100px",
            gap: "10px",
            zIndex: 2,
            "::before": {
                content: '""',
                background: "rgba(17, 17, 17, 0.85)",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: '4px'
            }
        }
    }

    if (window.theme === themeC.ComeOn) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "16px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#222222",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Hajper) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "16px",
            "::before": {
                content: '""',
                border: "solid 2px #373cf175",
                background: "#16219a7d",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: '25px',
                WebkitBackdropFilter: 'blur(5px)',
                backdropFilter: "blur(5px)"
            }
        }
    }

    if (window.theme === themeC.Snabbare || window.theme === themeC.Reviant) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--text-white)",
            padding: "16px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: window.theme === themeC.Reviant ? "#E71F00E5" : "#0086FFE5",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Lyllo) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#282B33CC",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Stugan) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#282B33CC",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }

    if (window.theme === themeC.Kryss) {
        boxInPicture = {
            position: "relative",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "16px",
            "::before": {
                content: '""',
                opacity: "0.7",
                background: "#282B33CC",
                position: "absolute",
                top: "0px",
                right: "0px",
                bottom: "0px",
                left: "0px",
                borderRadius: 'var(--radius)'
            }
        }
    }
    
    let iconColor: SxProps<Theme> = {
        color: "var(--text-white)"
    }

    let betFollowWin: SxProps<Theme> = {
        fontFamily: "var(--font-title)",
        fontSize: "var(--font-title-size)",
        letterSpacing: "var(--font-title-letter-spacing)",
        lineHeight: "30px",
        fontWeight: "var(--font-title-weight)",
        margin: 0,
        textTransform: "uppercase"
    }

    let marginLeft = "0px";
    let backgroundHeight = "376px";

    let betFollowWinText: SxProps<Theme> = {
        display: 'inline',
        fontFamily: "var(--font-body)"
    }

    if (window.theme === themeC.Dbet) {
        betFollowWin.fontFamily = "Righteous";
        betFollowWin.fontSize = "14px";
        betFollowWin.fontWeight = 400;
        betFollowWin.lineHeight = "17.38px";
    }

    if (window.theme === themeC.Video) {
        betFollowWin.fontSize = "14px";
        betFollowWin.fontWeight = 400;
        betFollowWin.lineHeight = "17.38px";
    }

    if (IsLeo(window.theme)) {
        marginLeft = "-20px";
        backgroundHeight = "260px";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 700;
        betFollowWin.lineHeight = "19px";
        betFollowWinText = {
            display: 'inline',
            fontSize: "12px",
            lineHeight: "14px"
        }
        iconColor.color = "white";
    }

    if (window.theme === themeC.Green) {
        betFollowWin = {
            fontFamily: "UnibetPro",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "20px",
            color: "#FFFFFF",
            margin: 0,
            textTransform: "none",
        };
        betFollowWinText = {
            fontFamily: "'Roboto'",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "16px",
            color: "#FFFFFF",
            display: "inline",
            textTransform: "none",
        };
    }

    if (window.theme === themeC.ComeOn) {
        backgroundHeight = "310px";
        betFollowWin.fontFamily = "Gravity";
        betFollowWin.fontSize = "22px";
        betFollowWin.fontWeight = 400;
        betFollowWin.textTransform = "none";
        iconColor.color = "#C0F9C8";
        text = "#F9F9F9";
    }

    if (window.theme === themeC.Hajper) {
        betFollowWin.textTransform = "none";
        betFollowWin.fontWeight = 500;
        betFollowWin.fontSize = "9.62px";
        betFollowWin.fontFamily = 'HajperSansMedium';
        betFollowWinText.fontSize = "12.83px";
        betFollowWinText.fontWeight = 500;
        betFollowWinText.fontStyle = 'italic';
        betFollowWinText.fontFamily = 'HajperSansMedium';
    }

    if (window.theme === themeC.Snabbare || window.theme === themeC.Reviant) {
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "none";
        if (window.theme === themeC.Snabbare) betFollowWin.fontStyle = 'italic';
    }

    if (window.theme === themeC.Lyllo) {
        betFollowWin.fontWeight = 700;
        iconColor.color = "white";
    }

    if (window.theme === themeC.Stugan) {
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "none";
        iconColor.color = "white";
    }

    if (window.theme === themeC.Kryss) {
        betFollowWin.fontFamily = "Fugaz One";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 700;
        betFollowWin.textTransform = "uppercase";
        iconColor.color = "white";
    }

    let groupIcon = `url(${kungGroup})`;
    let validIcon = `url(${kungValid})`;
    let winIcon = `url(${kungWin})`;
    let iconWidth = "47px";
    let iconHeight = "28px";

    let useCustomIcon = IsVideo(theme);

    if (theme === themeC.Hard) {
        betFollowWin.fontFamily = "var(--font-title)";
        betFollowWin.fontSize = "16px";
        betFollowWin.fontWeight = 900;
        betFollowWin.textTransform = "none";
        betFollowWin.marginBottom = "5px";
        betFollowWin.color = "var(--button-color)";
        betFollowWinText.fontFamily = "var(--font-body)";
        betFollowWinText.fontSize = "14px";
        betFollowWinText.fontWeight = 400;

        (boxInPicture['::before'] as any).background = "linear-gradient(0deg, rgba(21, 21, 21, 0.5), rgba(21, 21, 21, 0.5)),linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 100%)";
        backgroundImage = `url(${hardBackground})`;

        validIcon = `url(${hardBet})`;
        groupIcon = `url(${hardFollow})`;
        winIcon = `url(${hardWin})`;
        iconWidth = "24px";
        iconHeight = "24px";

        useCustomIcon = true;
    }



    if (window.theme === themeC.MrVegas) {
        groupIcon = `url(${mrVegasGroup})`;
        validIcon = `url(${mrVegasValid})`;
        winIcon = `url(${mrVegasWin})`;
        betFollowWin.fontSize = "12px";
        betFollowWin.fontWeight = 700;
        betFollowWin.lineHeight = "17.38px";
        betFollowWinText.fontSize = "10px";
        iconWidth = "40px";
        iconHeight = "40px";
    }

    if (window.theme === themeC.Mega) {
        groupIcon = `url(${megaGroup})`;
        validIcon = `url(${megaValid})`;
        winIcon = `url(${megaWin})`;
        betFollowWin.fontSize = "12px";
        betFollowWin.fontWeight = 700;
        betFollowWin.lineHeight = "17.38px";
        betFollowWinText.fontSize = "10px";
        iconWidth = "40px";
        iconHeight = "40px";
    }

    boxInPicture.marginLeft = "10px";
    boxInPicture.marginRight = "10px";
    boxInPicture.width = "auto";

    return (

        <Grid container sx={{
            width: "100%",
            height: backgroundHeight,
            background: backgroundImage,
            justifyContent: "center",
            alignItems: "center",
            backgroundPosition: window.theme === themeC.Green ? "center 52%" : "center center",
            backgroundSize: window.theme === themeC.Green ? "200%" : "cover",
            backgroundRepeat: "no-repeat",
            color: "var(--text-white)",
            position: "relative"
        }}>
            {theme === themeC.Green &&
                <Box sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: "linear-gradient(270deg, rgba(0, 0, 0, 0.45) 0%, rgba(0, 125, 63, 0.3) 100%)",
                    zIndex: 1,
                }} />
            }

            <Grid container justifyContent="center" >
                <Grid item sm={6} height="100%">
                    <Grid container direction="column" alignItems="center" sx={{ ...boxInPicture, position: 'relative' }}>

                        {theme !== themeC.Green && <IconButton
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                top: 4,
                                right: 4,
                                zIndex: 4,
                                color: text,
                                padding: '4px',
                            }}
                            aria-label="close banner"
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>}
                        {theme === themeC.Green &&
                            <Box sx={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 2,
                            }}>
                                <Unibet1x2Logo width={79} height={40} />
                            </Box>
                        }

                        <List className='list-item'>
                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {useCustomIcon ? <Box sx={{ backgroundImage: groupIcon, width: iconWidth, height: iconHeight, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <GroupsIcon sx={iconColor} />}

                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginLeft: { marginLeft }, marginTop: "5px", marginBottom: "5px" }}>

                                    <Typography
                                        sx={betFollowWin}
                                    >
                                        {t('join_title')}
                                    </Typography>

                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"
                                    >
                                        {t('join_text')}
                                    </Typography>
                                </Grid>
                            </ListItem>
                            {(IsVideo(theme)) &&
                                <ListItem>
                                    <Grid container direction="row" justifyContent="center" sx={{ marginTop: "10px" }}>
                                        <Box sx={{ border: "2px solid " + borderColor, width: "18px", height: "0px" }} />
                                    </Grid>
                                </ListItem>
                            }
                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {window.theme === themeC.Green ? <UnibetBetIcon width={16} height={16} /> :
                                        useCustomIcon ? <Box sx={{ backgroundImage: validIcon, width: iconWidth, height: iconHeight, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <TaskAltIcon sx={iconColor} />}
                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginTop: "5px", marginBottom: "5px", marginLeft: { marginLeft } }}>
                                    <Typography

                                        sx={betFollowWin}
                                    >
                                        {t('valid_title')}
                                    </Typography>
                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"

                                    >
                                        {t('valid_text')}
                                    </Typography>
                                </Grid>

                            </ListItem>

                            {(IsVideo(theme)) &&
                                <ListItem>
                                    <Grid container direction="row" justifyContent="center" sx={{ marginTop: "10px" }}>
                                        <Box sx={{ border: "2px solid " + borderColor, width: "18px", height: "0px" }} />
                                    </Grid>
                                </ListItem>
                            }

                            <ListItem disablePadding>
                                <ListItemIcon>
                                    {window.theme === themeC.Green ? <UnibetWinIcon width={16} height={16} /> :
                                        useCustomIcon ? <Box sx={{ backgroundImage: winIcon, width: iconWidth, height: iconHeight, backgroundSize: "contain", backgroundRepeat: "no-repeat" }} /> :
                                        <EmojiEventsIcon sx={iconColor} />}

                                </ListItemIcon>
                                <Grid container direction="column" sx={{ color: text, marginTop: "5px", marginBottom: "5px", marginLeft: { marginLeft } }}>
                                    <Typography

                                        sx={betFollowWin}
                                    >
                                        {t('win_together_title')}
                                    </Typography>

                                    <Typography
                                        sx={betFollowWinText}
                                        component="span"
                                        variant="body2"

                                    >
                                        {t('win_together_text')}
                                    </Typography>
                                </Grid>

                            </ListItem>
                        </List>
                    </Grid>
                </Grid>
            </Grid>

        </Grid>
    );

}
export default SyndicateInfoBox;